import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../types/types';
import { getList } from '../../../../../../store/model/list/selectors/getList';
import { ICardBatch } from '../types';
import { ICard } from '../../../../../../store/model/card/types';
import { IList } from '../../../../../../store/model/list/types';
import * as _ from 'underscore';
import { SNACKBAR_ID_CARD_MOVIED } from '../../../../../../view/react_components/snackbarsStack/effects/constants';
import { getMessages } from '../../../../../../store/constants';
import { getBoard } from '../../../../../../store/model/selectors/getBoardById';
import { listUpdateMinMaxOrderNumber } from '../../../../list/listUpdateMinMaxOrderNumber';
import { processDoneCardUpdate } from './processDoneCardUpdate';
import { processCardMoveToListUpdate } from './processCardMoveToListUpdate';
import { getBoardWorkListMove } from '../../../../../../store/model/board/selectors/getBoardWorkListMove';
import { processWorkingCardUpdate } from './processWorkingCardUpdate';
import {
    snackbarCardInfoDefault
} from '../../../../../../view/react_components/snackbarsStack/effects/variantInfo/cardInfoDefault';

export const processCardUpdate = (
    boardId: TBoardId,
    cardBatches: { [cardId: number]: ICardBatch },
    showMoveInfoPopup: boolean = true,
    calcOrderNumbers: boolean = true
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const board = getBoard(getState(), boardId);
        const doneList = board.statusLists && board.statusLists.doneId && getList(state, board.statusLists.doneId);
        const orderNumbers: number[] = [];
        for (let cardId in cardBatches) {
            const updateCard = cardBatches[cardId].card;
            if (updateCard.processingStatus === 'done') {
                dispatch(processDoneCardUpdate(Number(cardId), boardId, cardBatches, showMoveInfoPopup, calcOrderNumbers, orderNumbers));
            } else if (getBoardWorkListMove(state, boardId) && updateCard.processingPercent) {
                dispatch(processWorkingCardUpdate(Number(cardId), boardId, cardBatches, calcOrderNumbers, orderNumbers));
            }
            if (updateCard.listId) {
                dispatch(processCardMoveToListUpdate(Number(cardId), boardId, cardBatches))
            }
        }

        if (doneList) {
            dispatch(listUpdateMinMaxOrderNumber(doneList.id, orderNumbers))
        }
    };
    return action;
};

export const showMoveInfo = (
    dispatch: Dispatch,
    movedCards: ICard[],
    list: IList
) => {
    const firstText = getMessages().getPlural(movedCards.length, [getMessages().getText('snackbar.card.movied.list.first'), getMessages().getText('snackbar.cards.movied.list.first')]);
    const secondText = getMessages().getText('snackbar.card.movied.list.second');
    const thirdText = getMessages().getText('snackbar.card.movied.list.third');
    const cardNames = movedCards.map(card => _.escape(card.name)).join(', ');
    dispatch(snackbarCardInfoDefault({
        id: SNACKBAR_ID_CARD_MOVIED,
        text: `${firstText}<span class="progress-snackbar__span"> “${cardNames}” </span>${secondText}<span class="progress-snackbar__span"> “${_.escape(list.name)}” </span>${thirdText}`
    }));
};
